// Author thq
// Date 2021-04-16 00:58:58

class EmSppStorageLoc {
constructor({
        id = null,
        name = '',
        code = '',
        sslIdSst = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.sslIdSst = sslIdSst;
    this.remark = remark;
}
}

function newEntity() {
return new EmSppStorageLoc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppStorageLoc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppStorageLoc.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppStorageLoc.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sslNameSst',
        label: 'label.em.spareparts.emSppStorageLoc.grid.sslNameSst',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sslCodeSst',
        label: 'label.em.spareparts.emSppStorageLoc.grid.sslCodeSst',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppStorageLoc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    codeFilter : "",
    sslIdSstFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppStorageLoc.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.spareparts.emSppStorageLoc.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sslIdSstFilter',
        label: 'label.em.spareparts.emSppStorageLoc.filter.sslIdSst',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emSppStorageSst'
            ,correspondingField: 'id'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.spareparts.emSppStorageLoc.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppStorageLoc.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'sslIdSst',
        label: 'label.em.spareparts.emSppStorageLoc.entity.sslIdSst',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppStorageSst'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppStorageLoc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppStorageLoc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
